export const ALPACA_WALLET_FEE = "0.5%";

// https://github.com/alpacahq/cryptowallet/blob/933b95b62334ea7dc1a6bffaafae75c1e6f4f6c1/internal/workers/authorization/authorization.go#L183C54-L183C133
export const WITHDRAW_ACH_ERROR_REASON =
  "withdrawal of these crypto assets are unavailable due to ACH withholding limits";

export const WITHDRAW_ACH_ERROR_MESSAGE =
  "Your crypto withdrawal was rejected due to our ACH policy. 60 days have not yet passed from your most recent ACH deposit. Any ACH deposit will trigger a crypto withdrawal hold for 60 days.";

export const DEPOSIT_NETWORK_WARNING_MESSAGE =
  "Please note that for Ethereum based tokens (ERC-20) Alpaca supports the Ethereum blockchain. Do NOT send crypto to your Alpaca address over any other network, such as Avalanche, Optimism, Arbitrum, ink, GateChain, etc. Coins will be permanently lost, i.e. unrecoverable.";
